// src/services/api.js
// API via Supabase — substitui o Google Apps Script

const SUPABASE_URL = 'https://wlbafvaftkklhukycjpp.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndsYmFmdmFmdGtrbGh1a3ljanBwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODkyMjQ1MDIsImV4cCI6MjEwNDgwMDUwMn0.ESNkPFsVVFe1XscEhjQ12e0FHe1kv4I5j1YR4GPFOyc';

const headers = {
  'Content-Type': 'application/json',
  'apikey': SUPABASE_KEY,
  'Authorization': `Bearer ${SUPABASE_KEY}`,
};

// Helper: GET com filtros opcionais
const sbGet = async (table, params = '') => {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}?${params}`, { headers });
  if (!res.ok) throw new Error(await res.text());
  const data = await res.json();
  return { data };
};

// Helper: POST (insert)
const sbPost = async (table, body) => {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}`, {
    method: 'POST',
    headers: { ...headers, 'Prefer': 'return=representation' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await res.text());
  const data = await res.json();
  return { success: true, data };
};

// Helper: PATCH (update)
const sbPatch = async (table, id, body) => {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}?id=eq.${id}`, {
    method: 'PATCH',
    headers: { ...headers, 'Prefer': 'return=representation' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(await res.text());
  return { success: true };
};

// Helper: DELETE
const sbDelete = async (table, id) => {
  const res = await fetch(`${SUPABASE_URL}/rest/v1/${table}?id=eq.${id}`, {
    method: 'DELETE',
    headers,
  });
  if (!res.ok) throw new Error(await res.text());
  return { success: true };
};


// ── MAPEAMENTO snake_case → camelCase ───────────────────────────────────────
// O Supabase retorna snake_case; o frontend espera camelCase (igual ao GAS)

const mapRow = (row, mapa) => {
  const obj = { ...row };
  Object.entries(mapa).forEach(([snake, camel]) => {
    if (snake in obj) {
      obj[camel] = obj[snake];
      delete obj[snake];
    }
  });
  return obj;
};

const MAPS = {
  turmasBatismo: { data_batismo: 'dataBatismo', created_at: 'dataCriacao' },
  inscricoesBatismo: {
    turma_id: 'turmaId', turma_nome: 'turmaNome',
    nome_filho: 'nomeFilho', data_nascimento: 'dataNascimento',
    nome_pai: 'nomePai', nome_mae: 'nomeMae',
    nome_padrinho: 'nomePadrinho', nome_madrina: 'nomeMadrina',
    url_certidao: 'urlCertidao', url_doc_padrinhos: 'urlDocPadrinhos',
    url_doc_participantes: 'urlDocParticipantes', created_at: 'dataCriacao',
  },
  turmasNoivos: { data_inicio: 'dataInicio', data_final: 'dataFinal', created_at: 'dataCriacao' },
  inscricoesNoivos: {
    turma_id: 'turmaId', turma_nome: 'turmaNome',
    nome_noivo: 'nomeNoivo', endereco_noivo: 'enderecoNoivo',
    telefone_noivo: 'telefoneNoivo', comunhao_noivo: 'comunhaoNoivo',
    nome_noiva: 'nomeNoiva', endereco_noiva: 'enderecoNoiva',
    telefone_noiva: 'telefoneNoiva', comunhao_noiva: 'comunhaoNoiva',
    data_casamento: 'dataCasamento', url_doc_noivo: 'urlDocNoivo',
    url_doc_noiva: 'urlDocNoiva', url_comprovante: 'urlComprovante',
    created_at: 'dataCriacao',
  },
  solicitacoes: {
    local_batismo: 'localBatismo', ano_batismo: 'anoBatismo',
    nome_noivo: 'nomeNoivo', nome_noiva: 'nomeNoiva',
    data_casamento: 'dataCasamento', local_casamento: 'localCasamento',
    url_documento: 'urlDocumento', created_at: 'dataCriacao',
  },
  dizimistas: { data_nascimento: 'dataNascimento', created_at: 'dataCadastro' },
  capelas:    { created_at: 'dataCriacao' },
};

const mapList = (data, mapa) => Array.isArray(data) ? data.map(r => mapRow(r, mapa)) : data;

// ── TURMAS BATISMO ───────────────────────────────────────────────
export const getTurmasBatismo = async () => {
  const r = await sbGet('turmas_batismo', 'order=created_at.asc');
  return { data: mapList(r.data, MAPS.turmasBatismo) };
};

export const createTurmaBatismo = (form) =>
  sbPost('turmas_batismo', {
    nome:         form.nome,
    reuniao1:     form.reuniao1    || null,
    reuniao2:     form.reuniao2    || null,
    reuniao3:     form.reuniao3    || null,
    reuniao4:     form.reuniao4    || null,
    data_batismo: form.dataBatismo || null,
  });

export const updateTurmaBatismo = (form) =>
  sbPatch('turmas_batismo', form.id, {
    nome:         form.nome,
    reuniao1:     form.reuniao1    || null,
    reuniao2:     form.reuniao2    || null,
    reuniao3:     form.reuniao3    || null,
    reuniao4:     form.reuniao4    || null,
    data_batismo: form.dataBatismo || null,
  });

export const deleteTurmaBatismo = (id) =>
  sbDelete('turmas_batismo', id);

// ── INSCRIÇÕES BATISMO ───────────────────────────────────────────
export const getInscricoesBatismo = async () => {
  const r = await sbGet('inscricoes_batismo', 'order=created_at.desc');
  return { data: mapList(r.data, MAPS.inscricoesBatismo) };
};

export const createInscricaoBatismo = (form) =>
  sbPost('inscricoes_batismo', {
    turma_id:              form.turmaId              || null,
    turma_nome:            form.turmaNome            || null,
    opcao:                 form.opcao                || null,
    nome_filho:            form.nomeFilho            || null,
    data_nascimento:       form.dataNascimento       || null,
    telefone:              form.telefone             || null,
    nome_pai:              form.nomePai              || null,
    nome_mae:              form.nomeMae              || null,
    nome_padrinho:         form.nomePadrinho         || null,
    nome_madrina:          form.nomeMadrina          || null,
    url_certidao:          form.urlCertidao          || null,
    url_doc_padrinhos:     form.urlDocPadrinhos      || null,
    url_doc_participantes: form.urlDocParticipantes  || null,
  });

export const updateStatusBatismo = (id, status) =>
  sbPatch('inscricoes_batismo', id, { status });

// ── TURMAS NOIVOS ────────────────────────────────────────────────
export const getTurmasNoivos = async () => {
  const r = await sbGet('turmas_noivos', 'order=created_at.asc');
  return { data: mapList(r.data, MAPS.turmasNoivos) };
};

export const createTurmaNoivos = (form) =>
  sbPost('turmas_noivos', {
    nome:        form.nome,
    data_inicio: form.dataInicio || null,
    data_final:  form.dataFinal  || null,
  });

export const updateTurmaNoivos = (form) =>
  sbPatch('turmas_noivos', form.id, {
    nome:        form.nome,
    data_inicio: form.dataInicio || null,
    data_final:  form.dataFinal  || null,
  });

export const deleteTurmaNoivos = (id) =>
  sbDelete('turmas_noivos', id);

// ── INSCRIÇÕES NOIVOS ────────────────────────────────────────────
export const getInscricoesNoivos = async () => {
  const r = await sbGet('inscricoes_noivos', 'order=created_at.desc');
  return { data: mapList(r.data, MAPS.inscricoesNoivos) };
};

export const createInscricaoNoivos = (form) =>
  sbPost('inscricoes_noivos', {
    turma_id:        form.turmaId       || null,
    turma_nome:      form.turmaNome     || null,
    nome_noivo:      form.nomeNoivo     || null,
    endereco_noivo:  form.enderecoNoivo || null,
    telefone_noivo:  form.telefoneNoivo || null,
    comunhao_noivo:  form.comunhaoNoivo || null,
    nome_noiva:      form.nomeNoiva     || null,
    endereco_noiva:  form.enderecoNoiva || null,
    telefone_noiva:  form.telefoneNoiva || null,
    comunhao_noiva:  form.comunhaoNoiva || null,
    data_casamento:  form.dataCasamento || null,
    url_doc_noivo:   form.urlDocNoivo   || null,
    url_doc_noiva:   form.urlDocNoiva   || null,
    url_comprovante: form.urlComprovante|| null,
  });

export const updateStatusNoivos = (id, status) =>
  sbPatch('inscricoes_noivos', id, { status });

// ── SOLICITAÇÕES ─────────────────────────────────────────────────
export const getSolicitacoes = async () => {
  const r = await sbGet('solicitacoes', 'order=created_at.desc');
  return { data: mapList(r.data, MAPS.solicitacoes) };
};

export const createSolicitacao = (form) =>
  sbPost('solicitacoes', {
    tipo:            form.tipo            || null,
    nome:            form.nome            || null,
    telefone:        form.telefone        || null,
    finalidade:      form.finalidade      || null,
    local_batismo:   form.localBatismo    || null,
    ano_batismo:     form.anoBatismo      || null,
    nome_noivo:      form.nomeNoivo       || null,
    nome_noiva:      form.nomeNoiva       || null,
    data_casamento:  form.dataCasamento   || null,
    local_casamento: form.localCasamento  || null,
    url_documento:   form.urlDocumento    || null,
  });

export const updateStatusSolicitacao = (id, status) =>
  sbPatch('solicitacoes', id, { status });

// ── CAPELAS ──────────────────────────────────────────────────────
export const getCapelas = async () => {
  const r = await sbGet('capelas', 'order=nome.asc');
  return { data: mapList(r.data, MAPS.capelas) };
};

export const createCapela = (form) =>
  sbPost('capelas', form);

export const updateCapela = (form) =>
  sbPatch('capelas', form.id, {
    nome:      form.nome,
    foto:      form.foto      || null,
    foto2:     form.foto2     || null,
    foto3:     form.foto3     || null,
    endereco:  form.endereco  || null,
    horarios:  form.horarios  || null,
    descricao: form.descricao || null,
  });

export const deleteCapela = (id) =>
  sbDelete('capelas', id);

// ── DIZIMISTAS ───────────────────────────────────────────────────
export const getDizimistas = async () => {
  const r = await sbGet('dizimistas', 'order=nome.asc');
  return { data: mapList(r.data, MAPS.dizimistas) };
};

export const createDizimista = (form) =>
  sbPost('dizimistas', {
    nome:            form.nome            || null,
    telefone:        form.telefone        || null,
    data_nascimento: form.dataNascimento  || null,
    sexo:            form.sexo            || null,
    comunidade:      form.comunidade      || null,
    endereco:        form.endereco        || null,
    bairro:          form.bairro          || null,
    cidade:          form.cidade          || null,
  });

// ── INFORMATIVOS ─────────────────────────────────────────────────
export const getInformativos = () =>
  sbGet('informativos', 'ativo=eq.true&order=created_at.desc');

export const getAllInformativos = () =>
  sbGet('informativos', 'order=created_at.desc');

export const createInformativo = (form) =>
  sbPost('informativos', {
    titulo: form.titulo,
    texto:  form.texto  || form.conteudo || null,
    tipo:   form.tipo   || 'aviso',
    ativo:  true,
  });

export const updateInformativo = (form) =>
  sbPatch('informativos', form.id, {
    titulo: form.titulo,
    texto:  form.texto  || form.conteudo || null,
    tipo:   form.tipo   || 'aviso',
    ativo:  form.ativo ?? true,
  });

export const deleteInformativo = (id) =>
  sbDelete('informativos', id);

// ── INSTITUCIONAL ────────────────────────────────────────────────
export const getInstitucional = async () => {
  const res = await sbGet('institucional', 'limit=1');
  return { data: res.data?.[0] || null };
};

export const updateInstitucional = (id, form) =>
  sbPatch('institucional', id, form);


// ── LOGIN (AuthContext) ──────────────────────────────────────────
// Autenticação simples via tabela de usuários
export const login = async (usuario, senha) => {
  const res = await fetch(
    `${SUPABASE_URL}/rest/v1/usuarios?usuario=eq.${encodeURIComponent(usuario)}&senha=eq.${encodeURIComponent(senha)}&limit=1`,
    { headers }
  );
  if (!res.ok) throw new Error('Erro ao autenticar');
  const data = await res.json();
  if (!data || data.length === 0) throw new Error('Usuário ou senha inválidos');
  return { success: true, data: data[0] };
};

// ── DASHBOARD ────────────────────────────────────────────────────
export const getDashboard = async () => {
  const countRes = async (table, filtro = '') => {
    const res = await fetch(
      `${SUPABASE_URL}/rest/v1/${table}?select=id${filtro ? '&' + filtro : ''}`,
      { headers: { ...headers, 'Prefer': 'count=exact', 'Range-Unit': 'items', 'Range': '0-0' } }
    );
    return parseInt(res.headers.get('content-range')?.split('/')?.[1] || '0');
  };

  const [batismo, noivos, solicitacoes, dizimistas,
         pendentesBat, pendentesNoi, pendentesSol] = await Promise.all([
    countRes('inscricoes_batismo'),
    countRes('inscricoes_noivos'),
    countRes('solicitacoes'),
    countRes('dizimistas'),
    countRes('inscricoes_batismo', 'status=eq.Pendente'),
    countRes('inscricoes_noivos',  'status=eq.Pendente'),
    countRes('solicitacoes',       'status=eq.Pendente'),
  ]);

  return {
    data: {
      batismo,
      noivos,
      solicitacoes,
      dizimistas,
      pendentes: pendentesBat + pendentesNoi + pendentesSol,
    }
  };
};

// ── CADASTRAR DIZIMISTA (alias) ──────────────────────────────────
export const cadastrarDizimista = createDizimista;

// ── SACRAMENTOS ──────────────────────────────────────────────────
export const getSacramentos = async () => {
  const r = await sbGet('sacramentos', 'order=slug.asc');
  // Mapear 'texto' → 'conteudo' para compatibilidade com o frontend
  const data = (r.data || []).map(s => ({
    ...s,
    id:      s.slug,
    conteudo: s.texto,
  }));
  return { data };
};

export const updateSacramento = (id, form) =>
  sbPatch('sacramentos', id, form);
